export default "__VITE_PUBLIC_ASSET__0d39774d__"